import { useNavigate } from 'react-router-dom';
import LandingShell from '../components/LandingShell';
import { Button } from '../components/ui/button';
import './Legal.css';

/**
 * Catch-all for unmatched routes. Before this existed, an unknown path
 * rendered a blank white page (this router has no fallback), and — because
 * CloudFront rewrites S3 misses to /index.html with a 200 — a mistyped blog
 * URL would have produced exactly that blank page. A visible 404 at least
 * tells the visitor (and us, via the page title) what happened.
 */
const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <LandingShell navRight={<Button size="sm" onClick={() => navigate('/login')}>Log in</Button>}>
      <article className="legal-main">
        <h1 className="legal-h1">
          404 / <span className="legal-h1__accent">Page not found</span>
        </h1>
        <p className="legal-p" style={{ marginTop: 16 }}>
          The page you are looking for doesn&rsquo;t exist or has moved.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 24, flexWrap: 'wrap' }}>
          <Button onClick={() => navigate('/')}>Back to the homepage</Button>
          {/* Static generated page, not a SPA route. Plain navigation. */}
          <a className="ui-btn ui-btn--outline" href="/blog/">Visit the blog</a>
        </div>
      </article>
    </LandingShell>
  );
};

export default NotFoundPage;
